import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/controls/Button';
import From from '../../components/controls/Form';
import FormGroup from '../../components/controls/Form/components/FormGroup';
import InputField from '../../components/controls/Form/components/InputField';
import Heading from '../../components/controls/Typography/Heading';
import { TextParagraph } from '../../components/controls/Typography/TextBody';
import useAuthUtils from '../../utils/useAuthUtils';

import './ForgotPassword.less';

export const ForgotPassword = () => {
  const auth = useAuthUtils();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(null);
  const [email, setEmail] = useState('');
  const [isBusy, setIsBusy] = useState(false);

  const handleFormSubmit = async () => {
    setIsBusy(true);
    try {
      setErrorMessage(null);
      await auth.resetPasswordByEmail(email);
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      navigate('/retrievePassword', { state: { email } });
      setIsBusy(false);
    }
  };

  useEffect(() => {
    document.title = 'Letters Portal - Forgot Password';
  }, []);

  return (
    <main className="lsn-page lsn-page-forgot-password container">
      <Heading className="no-focus-outline text-center" tabIndex={0} aria-label={`Letters portal by Liaison Forgot Password`}>
        Forgot Password
      </Heading>

      <From
        title={`Can't remember your password?`}
        isNarrow
        hasBorder
        isButtonsStack
        onSubmit={handleFormSubmit}
        formAttr={{
          title: 'Forgot Password',
        }}
        buttons={<>
          <Button isBusy={isBusy} disabled={!email} primary submit>
            Send
          </Button>
          <Button ghost primary aria-label={'Cancel Button'} onClick={() => navigate('/login')} type='button'>
            Cancel
          </Button></>}
      >
        <TextParagraph>
          Enter the email address associated with your account and we will send you information about
          accessing your account.
        </TextParagraph>

        <FormGroup
          label={'Email'}
          required
          horizontal
          controlRender={(props) => <InputField
            inputType={'email'}
            title={'Email'}
            name={'email'}
            onChange={(n, value) => setEmail(value)}
            value={email}
            {
            ...(errorMessage ? { customErrorMessage: errorMessage } : {})
            }
            {...props}
          />}
        />
      </From>

    </main>
  );
};

export default ForgotPassword;
